'use strict';

/**
 *
 * @name: adminAccessConfig
 *
 */

function AdminAccessConfig($stateProvider) {

  'ngInject';

  function _resolveModuleControllers($ocLazyLoad) {

    return $ocLazyLoad.load('AdminAccessBundle');
  }

  $stateProvider
    .state('main.adminAccess', {
      abstract: true,
      templateProvider: $templateCache => $templateCache.get('admin-access.index.html'),
      controller: 'AdminAccessController',
      controllerAs: 'mainCtrl',
      resolve: {
        moduleControllers: _resolveModuleControllers
      }
    })
    .state('main.adminAccess.login', {
      url: 'admin/login',
      templateProvider: $templateCache => $templateCache.get('admin-access-login.index.html'),
      controller: 'AdminAccessLoginController',
      controllerAs: 'vm',
      resolve: {
        moduleControllers: _resolveModuleControllers
      }
    })
    .state('main.adminAccess.callendarMonth', {
      url: 'calendar/month',
      templateProvider: $templateCache => $templateCache.get('calendar/month/calendar-month.index.html'),
      controller: 'CalendarMonthController',
      controllerAs: 'vm',
      data: {
        requiresAdminAccess: true
      },
      resolve: {
        moduleControllers: _resolveModuleControllers
      }
    })
    .state('main.adminAccess.callendarPost', {
      url: 'calendar/:postId',
      templateProvider: $templateCache => $templateCache.get('calendar/post/calendar-post.index.html'),
      controller: 'CalendarPostController',
      controllerAs: 'vm',
      data: {
        requiresAdminAccess: true
      },
      resolve: {
        moduleControllers: _resolveModuleControllers
      }
    });
}

export default AdminAccessConfig;



// WEBPACK FOOTER //
// ./app/pages/admin-access/admin-access.config.js